import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";

export const SERVICE_PROVIDER_COORDINATOR_DIALOG_FIELD = {
  id: "serviceProviderCoordinator",
  type: ControlType.MultiDropdown,
  label: "External Service Provider Coordinators",
  order: 1,
  propertyName: "serviceProviderCoordinator",
  value: [],
  readableValue: [],
  required: true,
  visible: true,
  valid: true,
  readOnly: false,
} as Field;

export const SERVICE_PROVIDER_COORDINATOR_DIALOG_CONTROL = {
  id: "serviceProviderCoordinator",
  options: [],
} as any;
